import { render, staticRenderFns } from "./action-completed-button.vue?vue&type=template&id=56d43f06&lang=pug"
import script from "./action-completed-button.vue?vue&type=script&lang=js"
export * from "./action-completed-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports